import {
    FETCH_SENDER_REQUEST,
    FETCH_SENDER_SUCCESS,
    FETCH_SENDER_FAILURE,
} from '../actions/types/senders-action-types';


import { combineReducers } from 'redux';

function allIds( state = [], action ){
    let newState = [...state];
    switch( action.type ){
        case FETCH_SENDER_SUCCESS:
            if( !newState.includes( action.data.id ) ){
                newState = [...state, action.data.id];
            }
            break;
        default:
            return state;
    }

    return newState;
};

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_SENDER_SUCCESS:
            newState = { ...state };
            newState[action.data.id] = { ...action.data };
            break;
        default:
            return state;

    }

    return newState;
}

function isLoading( state = false, action ){
    switch( action.type ){
        case FETCH_SENDER_REQUEST:
            return true;
        case FETCH_SENDER_FAILURE:
        case FETCH_SENDER_SUCCESS:
        default:
            return false;
    }
}

export default combineReducers( {
    allIds,
    byId,
    isLoading,
} );
